import { format, parseISO, parseJSON } from "date-fns";
import ptBR from "date-fns/locale/pt-BR";

export const formatDate = (date) => {
  if (!date) return '';
  try {
    return format(parseISO(date.slice(0, 10)), "dd/MM/yyyy");
  } catch (error) {
    console.warn('Erro ao formatar data:', date, error);
    return '';
  }
};

export const formatDateToDatabase = (date) => {
  if (!date) return '';
  try {
    if (typeof date === "string") return format(parseJSON(date), "yyyy-MM-dd");
    return format(date, "yyyy-MM-dd");
  } catch (error) {
    console.warn('Erro ao formatar data para banco:', date, error);
    return '';
  }
};

export const formatToFileDate = (date) => {
  if (!date) return '';
  try {
    if (typeof date === "string") return format(parseJSON(date), "MM-yyyy");
    return format(date, "MM-yyyy");
  } catch (error) {
    console.warn('Erro ao formatar data para arquivo:', date, error);
    return '';
  }
};

export const formatMachineDate = (date) => {
  if (!date) return '';
  try {
    return format(parseISO(date.slice(0, 10)), "yyyy-MM-dd");
  } catch (error) {
    console.warn('Erro ao formatar data da máquina:', date, error);
    return '';
  }
};

export const formatMachineDateBR = (date) => {
  if (!date) return '';
  try {
    return format(parseISO(date.slice(0, 10)), "dd/MM/yyyy");
  } catch (error) {
    console.warn('Erro ao formatar data da máquina BR:', date, error);
    return '';
  }
};

export const formatDateHour = (date) => {
  if (!date) return '';
  try {
    return format(parseJSON(date), "dd/MM/yyyy - HH:mm", {
      locale: ptBR,
    });
  } catch (error) {
    console.warn('Erro ao formatar data:', date, error);
    return '';
  }
};

export const formatDateHourMinuteSecond = (date) => {
  if (!date) return '';
  try {
    return format(date, "dd/MM/yyyy - HH:mm:ss", {
      locale: ptBR,
    });
  } catch (error) {
    console.warn('Erro ao formatar data com segundos:', date, error);
    return '';
  }
};

export const createDateFromString = (dateStr) => {
  if (!dateStr) return null;
  try {
    return new Date(parseISO(dateStr));
  } catch (error) {
    console.warn('Erro ao criar data a partir de string:', dateStr, error);
    return null;
  }
};
